import axios from 'axios';

/** True when an axios/React Query request was aborted via AbortSignal. */
export function isAbortError(err) {
  return axios.isCancel(err) || err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError';
}

/** True when the browser could not reach the API (refused, offline, DNS, etc.). */
export function isApiConnectionError(err) {
  if (!err || isAbortError(err)) return false;

  const code = err?.code;
  if (code === 'ERR_NETWORK' || code === 'ERR_CONNECTION_REFUSED') return true;

  // Axios network failures: request sent but no HTTP response received.
  if (!err?.response && err?.request) return true;

  const message = String(err?.message || '');
  if (/network error/i.test(message)) return true;
  if (/connection refused/i.test(message)) return true;

  return false;
}

/** User-facing message for known API error types, or null if unknown. */
export function getApiErrorMessage(err) {
  if (isApiConnectionError(err)) {
    return 'Issue connecting to the API';
  }
  return null;
}

/** Pull a useful message from an axios/API error response body. */
export function getResponseErrorDetail(err) {
  const data = err?.response?.data;
  if (data == null) return null;
  if (typeof data === 'string' && data.trim()) return data.trim();
  if (typeof data !== 'object') return null;

  const detail =
    data.detail ||
    data.Detail ||
    data.title ||
    data.Title ||
    data.message ||
    data.Message ||
    data.error ||
    data.Error;
  if (typeof detail === 'string' && detail.trim()) return detail.trim();
  return null;
}

/** Login-specific message when the API cannot be reached / rejects auth. */
export function getLoginErrorMessage(err, fallback) {
  if (isApiConnectionError(err)) {
    return 'Unable to reach API to Authenticate login';
  }
  return getResponseErrorDetail(err) || fallback;
}
